module.exports = __webpack_public_path__ + "static/media/Reach_2021_900x500_v1-02-1.f5bf0dbf.png";